export default "__VITE_ASSET__BEiZcvAT__"